import React from 'react';
import './index.css';
import CommentType from './CommentType';
import CommentList from './CommentList';
import MoreStatus from '../../MoreStatus';
import PlaceholderImage from '../../PlaceholderImage';
import Detector from '../../../utils/detector';
export default class Comment extends React.Component{
  render(){
    let {className, showCountTitle, handleChangeCommentType } = this.props;
    let { commentType, comments, moreStatus} = this.props;
    if(!comments){
      return null;
    }
    //兼容接口list 为 null的清情况
    if(!comments.list){
      comments.list = [];
    }
    return(
      <div className={`comments ${className}`}>
        {showCountTitle ? 
          <h4>评价 
            {comments.count && comments.count.all ? `（${comments.count.all}）` : ''}
          </h4> : null
        }
        <CommentType 
          count={comments.count || {}}
          acitveType={commentType}
          handleChangeCommentType={handleChangeCommentType}
        />
        <div className="comment-list-wrap">
          {
            comments.list && comments.list.length ? 
              <CommentList commentList={comments.list} />
              : 
              moreStatus === 'PENDING' ?
                <PlaceholderImage loadImage='commentsLoadImage.svg' />:
                <div className="no-comments">暂无相关评价</div>
          }

          { comments.list.length === 3 && showCountTitle ? 
            <p className={`comment-more ${Detector.os.name}`} onClick={this.goToViewMore}>
              查看全部评价<i className="icon icon-arrow"></i>
            </p> : null
          }
          { moreStatus && comments.list.length ? <MoreStatus status={moreStatus} /> : null }
        </div>
      </div>
    );
  }

  goToViewMore = ()=>{
    this.props.showMore('comments');
  }
}



// WEBPACK FOOTER //
// ./src/components/Poi2/Comment/index.js